const apiUrl = process.env.REACT_APP_API_URL;

export const getInventory = async(categories, locations, statuses, qtyList) => {
    const token = sessionStorage.getItem('token');
    let obj = { categories, locations, statuses, qtyList }    
    const url =  `${apiUrl}/api/items/getInventory`;       
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify(obj)
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return [];
    }
}
export const getItem = async(id) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/items/getItem/${id}`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return {};
    }
}

export const getLogs = async(id) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/items/getLogs/${id}`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },    
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return [];
    }
}

export const getItemByToken = async(token) => {
    const url =  `${apiUrl}/api/items/getItemByToken/${token}`;
    console.log('🌐 URL del servicio:', url);
    console.log('🔑 Token recibido en servicio:', token);
    
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json'
         },    
    };
    
    console.log('📤 Request options:', requestOptions);
    
    try {
       console.log('📡 Haciendo fetch...');
       const response = await fetch(url, requestOptions);
       console.log('📥 Response status:', response.status);
       console.log('📥 Response ok:', response.ok);
       
       const data = await response.json();
       console.log('📦 Data parseada:', data);
       
       // El backend retorna el objeto directamente, no envuelto en { result, data }
       // Normalizar la respuesta para que ViewItemByToken funcione
       if (data && data.id) {
           console.log('✅ Retornando objeto normalizado con result: true');
           return { result: true, data: data };
       } else {
           console.log('❌ No se encontró el objeto');
           return { result: false };
       }
    } catch (error) {
        console.log('💥 Error en catch del servicio:', error);
        return { result: false };
    }
}


